import React from "react";
import CheckoutMain from "../components/Product/CheckoutMain";
import Header from "../components/Shared/Header";
import Footer from "../components/Shared/Footer";

function Checkout() {
  return (
    <div>
         <Header />
      <CheckoutMain />
      <Footer />
    </div>
  );
}

export default Checkout;
